"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AuthenticationType;

(function (AuthenticationType) {
  AuthenticationType["noAuth"] = "noAuth";
  AuthenticationType["bearerToken"] = "bearerToken";
})(AuthenticationType = exports.AuthenticationType || (exports.AuthenticationType = {}));